import Vue from 'vue'
import ProjectApi from 'api/project'

const PROJECT_GET = 'PROJECT_GET'
const PROJECT_SET_CHECKID = 'PROJECT_SET_CHECKID'
const CHECK_STATE_INTERVAL = 2000

// initial state
const state = {
  items: {}, // store projects in key/value pair
  checks: {} // store checks for each project
}

const mutations = {
  [PROJECT_GET](state, params) {
    Vue.set(state.items, params.id, params)
  },
  [PROJECT_SET_CHECKID](state, { id, checkID, lowerEt, upperEt }) {
    Vue.set(state.checks, id, {
      checkID: checkID,
      lowerEt: lowerEt || 1,
      upperEt: upperEt || 3
    })
  }
}

// actions
const actions = {
  // get list of projects
  index({ rootGetters }, params) {
    return ProjectApi.index(Object.assign({}, params, {
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    }))
  },

  // get list of projects' states
  states(_, params) {
    return ProjectApi.states(params)
  },

  // crate a project
  create({ rootGetters, commit, dispatch }, params) {
    return ProjectApi.create(Object.assign({}, params, {
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    })).then(res => {
      commit(PROJECT_GET, res.data)

      // 创建项目会消耗永久额度 所以需要re-pull额度
      dispatch('quota/index', { force: true }, { root: true })
      return res
    })
  },

  // update a project
  update({ commit }, params) {
    return ProjectApi.update(params.id, params).then(res => {
      commit(PROJECT_GET, res.data)
      return res
    })
  },

  // soft-delete a project
  destroy(state, id) {
    return ProjectApi.destroy(id)
  },

  // cancel checkstate
  cancelCheckState({ state, commit }, id) {
    let cid = state.checks[id]
    if (cid) {
      window.clearTimeout(cid)
      commit(PROJECT_SET_CHECKID, { id: id, checkID: null })
    }
    Promise.resolve()
  },

  // start to check state of a project
  checkState({ state, dispatch, commit }, id) {
    return new Promise((resolve, reject) => {
      let clearTimeout = () => {
        let cid = state.checks[id]
        if (cid) {
          window.clearTimeout(cid)
          commit(PROJECT_SET_CHECKID, { id: id, checkID: null })
        }
      }

      let check = () => {
        ProjectApi.state(id).then(res => {
          let state = res.data.state
          let estimatedTime = res.data.estimated_time

          if (state === 'completed' || state === 'halted') {
            // finished check
            clearTimeout()
            dispatch('get', { id: id, force: true })
            resolve(id)
          } else {
            commit(PROJECT_SET_CHECKID, {
              id: id,
              checkID: window.setTimeout(check, CHECK_STATE_INTERVAL),
              lowerEt: estimatedTime.lower,
              upperEt: estimatedTime.upper
            })
          }
        }).catch(err => {
          reject(err)
        })
      }

      clearTimeout()
      check()
    })
  },

  // stats
  stats({ state }, id) {
    return ProjectApi.stats(id)
  },

  // form-records
  formRecords({ state }, params) {
    return ProjectApi.formRecords(params)
  },

  // delete form-record items
  deleteFormRecords({ state }, params) {
    return ProjectApi.deleteFormRecords(params)
  },

  // get
  get({ state, commit }, { id, force }) {
    let _project = state.items[id]

    return (_project && !force) ? Promise.resolve(_project) : ProjectApi.show(id).then(res => {
      commit(PROJECT_GET, res.data)
      return res.data
    })
  },

  // record_qrcode
  recordQrcode(_, id) {
    return ProjectApi.recordQrcode(id)
  },

  // export related
  createExport(_, params) {
    return ProjectApi.createExport(params)
  },

  checkExport(_, id) {
    return ProjectApi.checkExport(id)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/project.js